<template>
    <div class="ksBox">
        <div class="searchItem flex ">
            <div class="item">
                <el-input
                        class="mr10"
                        placeholder="名称 搜索"
                        v-model="gsinput"
                        clearable>
                </el-input>
                <!--<el-select class="mr10" v-model="state" placeholder="请选择">
                    <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>-->

            </div>
            <div class="item">
                <span class="searchName">同步时间:</span>
                <template>
                    <div class="block tbBox" >
                        <el-date-picker style="width: 100%" clearable
                                        v-model="create_date"
                                        format="yyyy-MM-dd"
                                        value-format="yyyy-MM-dd"
                                        type="date"
                                        placeholder="选择日期">
                        </el-date-picker>
                    </div>

                </template>
                <el-button type="primary" @click="searchData" style="margin-left: 30px">检索</el-button>
            </div>

            <div class="item-right flex">
                <div class="xz">
                    <el-button type="primary" @click="addPro">新增</el-button>
<!--                    <el-button type="primary">保存</el-button>-->
                    <el-button type="primary" @click="allDingYue">查看订阅</el-button>
                </div>
            </div>
        </div>
        <!--表格-->
        <div class="dataTable mt20">
            <template>
                <el-table
                        :header-cell-style="{background:'#eef1f6',color:'#000'}"
                        ref="multipleTable"
                        :data="tableData"
                        tooltip-effect="dark"
                        style="width: 100%"
                        height="650"
                        @selection-change="handleSelectionChange">
                    <el-table-column
                            align="center"
                            type="selection"
                            width="55">
                    </el-table-column>
                    <el-table-column
                            prop="i_id"
                            align="center"
                            label="ID"
                            width="100">
                    </el-table-column>
                    <el-table-column
                            prop="vc_name"
                            align="center"
                            label="名称"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            width=""
                            prop="vc_nickname"
                            align="center"
                            label="别名"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            width=""
                            prop="vc_ename"
                            align="center"
                            label="英文名"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="file_path"
                            align="center"
                            label="图片"
                            show-overflow-tooltip>
                        <template  slot-scope="scope">
                            <div style="height: 50px;width: 50px;display: inline-block;vertical-align: middle;">
                                <img style="height: 50px;width: 50px" :src="scope.row.file_path"  v-if="scope.row.file_path!=''"/>
                            </div>

                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="dt_createtime"
                            align="center"
                            label="时间"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            label="操作"
                            width="200">
                        <template slot-scope="scope">
                            <!--                                        <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>-->
                            <el-button type="text" size="small" style="color: #67C23A"  @click="addSpecification(scope.row)">查看规格 |</el-button>
                            <el-button type="text" size="small" style="color: #409EFF"  @click="editData(scope.row)">编辑 |</el-button>
                            <el-button type="text" size="small" style="color: #67C23A"  @click="DingYue(scope.row)">查看订阅</el-button>

                        </template>
                    </el-table-column>
                </el-table>
                <div class="tableBottom flex fle-item flex-just mt20">
                    <div class="tbLeft">
<!--                        <el-button type="primary">批量发布</el-button>-->
                        <el-button type="primary">批量冻结</el-button>
                    </div>
                    <div class="tbRight">
                        <div class="paginationBox textRig" >
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    @current-change="pageCurrentChange"
                                    :current-page.sync="currentPage"
                                    :total="tableTotal">
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </template>
        </div>
        <el-dialog title="查看订阅"  :visible.sync="dialogFormVisibleData" @close="cancelData" :close-on-click-modal="false" width="80%" >
            <sub-scribe  v-if="dialogFormVisibleData" :subscribe="subscribe"></sub-scribe>
        </el-dialog>
        <el-dialog :title="title"  :visible.sync="dialogFormVisibleEdit" v-if="dialogFormVisibleEdit" @close="cancelEdit" :close-on-click-modal="false" width="900px" >
            <adddialog :adddialogdata="adddialogdata" @cancelEdit="cancelEdit" @getMDSysMessage="getMDSysMessage"></adddialog>
        </el-dialog>
        <el-dialog title="添加规格"  :visible.sync="dialogFormVisibleSpecification"  @close="cancelSpecification" :close-on-click-modal="false" width="80%" >
            <add-specification v-if="dialogFormVisibleSpecification" :specification="specification" @getMDSysMessage="getMDSysMessage"></add-specification>
        </el-dialog>
    </div>
</template>

<script>
    import * as API from  "./api";
    import {filerequest_url} from './api';
    import { mapState } from "vuex"
    import {mapActions} from "vuex";
    import AddSpecification from "./AddSpecification";
    import adddialog from "./adddialog"
    import SubScribe from "./SubScribe";
    export default {
        name: "index",
        components: {AddSpecification,SubScribe,adddialog},
        data(){
            return{
                state:"",
                create_date:"",
                options: [
                    {
                        value: '001',
                        label: '发送中'
                    },{
                        value: '002',
                        label: '已发送'
                    }, {
                        value: '003',
                        label: '异常'
                    }],
                file_path:"",
                subscribe:{},
                GetChooseData:[
                ],
                GetEditData:{},
                title:"",
                isaddbtn:false,
                rulesadd: {
                    vc_name: [
                        {required: true, message: '请输入名称', trigger: 'blur'},
                    ],
                },
                search:{},
                begin_time:"",
                end_time:"",
                isShow:false,
                dialogFormVisibleData:false,
                dialogFormVisibleEdit:false,
                dialogFormVisibleNew:false,
                dialogFormVisibleSpecification:false,
                gsinput:"",
                location:"",
                company:"",
                fileName:"",
                fileType:"",
                fileUrl:"",
                value:"",
                i_uid:"",
                tableData: [

                ],
                /*specTable:[],*/
                tableTotal:0,
                pageSize:1,
                currentPage:1,
                i_id:0,
                currentRow: null,
                specification:{},
                adddialogdata:{},
            }
        },
        mounted() {
            this.getMDSysMessage();
        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),
            async getMDSysMessage(pageSize){
                //console.log("------------------",spec,pageSize)
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                };
                if(pageSize!=undefined) {
                    //console.log(pageSize,"addddd")
                    this.currentPage=pageSize;
                    this.pageSize=pageSize;
                }
                let param={
                    i_uid:"",
                    app:"",
                    token:"",
                    version:"",
                    page_size:this.pageSize,
                    // pageStart: (this.pageIndex-1)*this.pageSize,
                    page_count:10,
                    search:{
                    vc_name:this.gsinput,
                        vc_cd:"",
                        vc_gykh:"",
                        vc_bzstyle: "",
                        f_weight: "",
                        vc_unit:"",
                },
                    //vc_state:this.state,
                    data_type: "product",
                    i_id:0,
                };
                //console.log(param)
                let res=await API.getMDSysMessage(param);
                if(res.code==1){
                        this.tableData= res.data;
                        this.tableTotal=res.count;
                } else if (res.code == -2) {
                   this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                };

            },
            searchData(){
                this.pageSize=1;
                this.currentPage=1;
                this.getMDSysMessage();
            },
            //新增
            addPro(){
                this.title="新增产品大类";
                this.adddialogdata={
                    name:"",
                    i_id:0,
                    value:{file_path: ""},
                    pid:0,
                    title:"新增产品大类",
                    pageSize:1,
                };
                this.dialogFormVisibleEdit=true;
            },
            //编辑
            editData(value,index){
                //console.log(value,"------")
                this.title="编辑产品大类";
                this.adddialogdata={
                    name:value.vc_name,
                    i_id:value.i_id,
                    pid:value.pid,
                    value:value,
                    title:"编辑产品大类",
                    pageSize:this.pageSize
                };
                this.dialogFormVisibleEdit=true;
            },
            //查看订阅
            DingYue(value){
                this.isShow=false;
                this.dialogFormVisibleData=true;
                /*this.i_id=value.i_id;*/
                this.subscribe=value;
                //console.log("value",value);
                //this.relationData(value);
            },
            allDingYue(value){
                this.isShow=true;
                this.dialogFormVisibleData=true;
                this.subscribe={
                    i_id:0,
                    isShow:this.isShow,
                };
                //this.relationData(value);
            },
            cancelEdit(){
                this.adddialogdata={};
                this.dialogFormVisibleEdit=false;
            },
            cancelSpecification(){this.dialogFormVisibleSpecification=false;},
            cancelData(){
                this.dialogFormVisibleData=false;
            },
            //添加规格tag
            addSpecification(value){
                this.i_id=value.i_id;
                this.name=value.vc_name;
                this.specification={
                    name:this.name,
                    i_id:this.i_id,
                    i_flag:value.i_flag,
                };
                this.dialogFormVisibleSpecification=true;
            },
            pageCurrentChange(val){
                this.pageSize=val;
                this.currentPage=val;
                this.getMDSysMessage();
            },
            handleSelectionChange:function(val) {
                this.multipleSelection = val;
                // console.log(val)
            },


        },
    }
</script>

<style lang="scss"  scoped>
    .flex{
        display: flex;
    }
    .fle-item{
        align-items: center;
    }
    .flex-just{
        justify-content: space-between;
    }
    .mr10{
        margin-right: 10px;
    }
    .mt20{
        margin-top: 20px;
    }
    .ksBox{
        height: 100%;
        margin-top: 20px;
    }
    .searchName{
       min-width: 85px;
    }
    .searchItem{
        .item{
            width: 30%;
            /deep/{


            }
        }
        .item-right{
            width: 40%;
            justify-content: flex-end;

            .xz{
                margin-left: 10px;
            }
        }
    }
    .uploadFile{
        /*height: 80px;*/
        overflow: hidden;
        position: relative;
        .uploadBtn{
            width: 150px;
        }
        .upload-input{
            width: 150px;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            opacity: 0;
        }
    }
    .dataSpan{
        width: 100px;
        display: inline-block;
        padding-top: 10px;
    }
    .backColor{
        color: #606266;
    }
    .redColor{
        color: red;
    }
    /deep/{
        .el-dialog{
            font-size: 20px;
            min-width: 980px;
        }
        .el-dialog__header{
        background-color: #3e82e8;
        }
        .el-table td, .el-table th{
            padding: 5px 0;
        }
        .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
        color: white;
        }
    }
</style>